import React from 'react';
import Hidden from '@mui/material/Hidden';
import ContactSupportDialog from './ContactSupportDialog';
import { initializeApp } from "firebase/app"
import { getFunctions, httpsCallable } from "firebase/functions";
import settings from '../../common/settings';



export default function ContactFormController( props ) {

  const firebaseApp = initializeApp(settings.credentials.firebase);

  const functions = getFunctions(firebaseApp, 'europe-west1');
  
  function sendContactUsEmail(data) {

    return httpsCallable(functions, 'sendContactUsMail')(data)
      .then(function(result) {
        var response = result.data.result;
        if (response === 'OK') {
          return {
            success: true,
          };
        } else {
          return {
            success: false,
            message: "Sorry, we can't send your email now. Please try getting in touch with us in another way."
          };
        }
      })
      .catch((e) => {
        return {
          success: false,
          message: "Sorry, something went wrong and we can't send your email now."
        };
      });
  }

  return (
    <>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
              <ContactSupportDialog
              fullScreen
              open={!!props.showDialog}
              title="Contact Us"
              onClose={()=> {return true;}}
              onCancelClick={() => props.showDialogController(false)}
              onOkClick={() => props.showDialogController(false)}
              sendEmail={sendContactUsEmail}
              highlightOkButton={true}
              okText="Send"
              />
            </Hidden>

            <Hidden only={['xs']}>
              <ContactSupportDialog
              open={!!props.showDialog}
              title="Contact Us"
              onClose={()=> {return true;}}
              onCancelClick={() => props.showDialogController(false)}
              onOkClick={() => props.showDialogController(false)}
              sendEmail={sendContactUsEmail}
              highlightOkButton={true}
              okText="Send"
              />
            </Hidden>
    </>
    
  );

}